import { FETCH_ORDER_TRACKING_SUCCESS, FETCH_ORDER_TRACKING_REQUEST, FETCH_ORDER_TRACKING_FAILURE, FETCH_ORDER_TRACKING_REST } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getOrderTrackingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDER_TRACKING_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_ORDER_TRACKING_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_ORDER_TRACKING_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_ORDER_TRACKING_REST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        default:
            return state;
    }
};
export default getOrderTrackingReducer;
